/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { environment } from "./environments/environment";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { provideAuth0 } from "@auth0/auth0-angular";
import { LIB_ENVIRONMENT } from "./app/modules/vnext/services/environment.token";
import { ErrorGenericHandler } from "./app/services/error.generic.handler";
import { NbDatepickerModule, NbDialogModule, NbMenuModule, NbSidebarModule, NbStepperComponent, NbThemeModule, NbToastrModule } from "@nebular/theme";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { authInterceptor } from "./app/modules/vnext/auth/auth-http-interceptor";
import { ThemeModule } from "./app/@theme/theme.module";
import { CoreModule } from "./app/@core/core.module";
import { AppRoutingModule } from "./app/app-routing.module";
import { provideState, provideStore } from "@ngrx/store";
import { lookupReducer } from "./app/modules/vnext/services/reducers/lookup.reducer";
import { provideEffects } from "@ngrx/effects";
import { LookupEffects } from "./app/modules/vnext/services/effects/lookup.effects";
import { workflowReducer } from "./app/modules/vnext/services/reducers/workflow.reducer";
import { WorkflowEffects } from "./app/modules/vnext/services/effects/workflow.effects";
import { loadingInterceptor } from "./app/@core/interceptors/loading.interceptor";

if (environment.production) {
  enableProdMode();
}

// platformBrowserDynamic()
//   .bootstrapModule(AppModule)
//   .catch((err) => console.error(err));

bootstrapApplication(AppComponent, {
  providers: [
    // Angular 21 bootstraps zoneless by default; Nebular and the existing components still rely on
    // Zone.js to trigger change detection, so keep it until they are migrated.
    provideZoneChangeDetection(),
    { provide: LIB_ENVIRONMENT, useValue: environment },
    {
      provide: ErrorHandler,
      useClass: ErrorGenericHandler,
    },
    {
      provide: NbStepperComponent,
    },
    provideHttpClient(withInterceptors([
      authInterceptor,
      loadingInterceptor,
    ])),
    importProvidersFrom(NbThemeModule.forRoot()),
    importProvidersFrom(NbMenuModule.forRoot()),
    importProvidersFrom(NbSidebarModule.forRoot()),
    importProvidersFrom(CoreModule.forRoot()),
    importProvidersFrom(ThemeModule.forRoot()),
    importProvidersFrom(AppRoutingModule),
    importProvidersFrom(NbDialogModule.forRoot()),
    importProvidersFrom(BrowserAnimationsModule),
    importProvidersFrom(NbToastrModule.forRoot()),
    importProvidersFrom(NbDatepickerModule.forRoot()),
    provideStore(),
    provideState({ name: 'lookups', reducer: lookupReducer }),
    provideEffects(LookupEffects),
    provideState({ name: 'workflow', reducer: workflowReducer }),
    provideEffects(WorkflowEffects),
    provideAuth0({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      cacheLocation: "localstorage",
      useRefreshTokens: true,
      authorizationParams: {
        audience: environment.auth0.audience,
        redirect_uri: window.location.origin + "/login",
      },

    }),
  ],
})
